<template>
  <!--单个优惠券-->
  <div class="coupon-item">
    <div class="coupon-info" @click="event_toUse">
      <div class="coupon-price">
        <span class="currency-symbol">￥</span>
        <span class="currency-num">{{ticketInfo.amount}}</span>
        <div class="coupon-limit">{{ticketInfo.useChannelText}}</div>
      </div>
      <div class="coupon-condition">
        <p class="condition-desc">{{ticketInfo.name}}&nbsp;{{ticketInfo.desc}}</p>
        <div class="to-use-btn" v-if="ticketType === 1">去使用</div>
      </div>
      <div class="line"></div>
      <div class="period-and-instructions">
        <span class="period" :class="{urgent: ticketInfo.isUrgent}">{{ticketInfo.useDateDesc}}</span>
        <span v-if="ticketInfo.details" class="instructions" @click.stop="event_showDirection">
          使用说明
          <i class="iconfont" :class="foldIconClassName"></i>
        </span>
      </div>
    </div>
    <div class="direction-of-use" ref="direction">
      <p class="direction-text" v-show="showDirection">{{ticketInfo.details}}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    ticketInfo: {
      // 优惠券信息
      type: Object
    },
    ticketType: {
      // 优惠券状态类型 1-未使用 2-已使用 3-已失效
      type: Number
    }
  },
  data() {
    return {
      showDirection: false
    }
  },
  computed: {
    foldIconClassName() {
      // 使用说明icon的className
      return this.showDirection ? 'icon-shouqi' : 'icon-zhankai'
    }
  },
  methods: {
    event_showDirection() {
      this.showDirection = !this.showDirection

      // 以下为展开动画，由于APP中没有加动画，在此也不加
      // if (this.showDirection) {
      //   this.showDirection = false;
      //   this.$refs.direction.style.height = 0 + 'px';
      // } else {
      //   this.showDirection = true;
      //   this.$refs.direction.style.height = this.$refs.direction.scrollHeight + 'px';
      // }
    },
    event_toUse() {
        const _this = this;
        const {useChannel, useChannelText} = _this.ticketInfo;
        // 如果优惠券不是未使用状态
        if (_this.ticketType !== 1) {
          return;
        }

        //	useChannel  0:适用所有平台, 1:PC端, 2:小程序端, 3:H5端, 4:APP端。 适用于多个品台用"," 拼接，例如："1,2,3"
        if (useChannel.indexOf('0') === -1 && useChannel.indexOf('3') === -1 ) {
          _this.$emit('emit_showDialog', {
            useChannel,
            useChannelText
          });
          return;
        }
        const showProductId= this.ticketInfo.showProductId;
        // 有showProductId字段，代表是单品
        if (showProductId) {
          window.location.href = `//m.secoo.com/proDetail_1217.html?prodId=${showProductId}`;
        } else { // 不是单品，调到用券专区页（搜索页）
          // alert('这里是要跳到搜索页的');
          window.location.href = `//m.secoo.com/v1/list/?type=ticket&ticketId=${this.ticketInfo.ticketTypeId}`;
        }
    }
  }
}
</script>

<style lang="scss" scoped>
.coupon-item {
  width: toRem(690);
  margin-bottom: toRem(30);
  .coupon-info {
    position: relative;
    width: 100%;
    height: toRem(260);
    padding: toRem(28) toRem(30) 0 toRem(90);
    background-color: #fff;
    box-shadow: 0 toRem(5) toRem(15) 0 rgba(0, 0, 0, 0.06);
    box-sizing: border-box;
    background: #fff url(../../../public/img/mall.png) no-repeat 0 0 / toRem(66)
      100%;
    overflow: hidden;
    .coupon-price {
      height: toRem(91);
      margin-bottom: toRem(8);
      line-height: toRem(91);
      font-family: Futura-Medium;
      color: #000;
    }
    .currency-symbol {
      font-size: toRem(42);
    }
    .currency-num {
      font-size: toRem(70);
    }
    .coupon-limit {
      position: absolute;
      top: toRem(14);
      right: toRem(30);
      font-family: PingFangSC-Regular;
      font-size: toRem(22);
      color: #F8A120;
    }
    .coupon-condition {
      display: flex;
      justify-content: space-between;
      height: toRem(44);
      margin-bottom: toRem(30);
      line-height: toRem(44);
      font-family: PingFangSC-Medium;
      color: #000;
      font-size: toRem(28);
      .condition-desc {
        /*width: toRem(470);*/
        flex: 1;
        height: 100%;
        padding-right: toRem(10);
        overflow: hidden;
        @extend %text-ellipsis;
      }
      .to-use-btn {
        flex: 0 0 toRem(100);
        /*width: toRem(100);*/
        height: toRem(44);
        text-align: center;
        color: #fff;
        font-size: toRem(24);
        background-color: #ffb81c;
      }
    }
    .line {
      width: 100%;
      @include border-1px-b(#e1e1e1);
    }
    .period-and-instructions {
      position: relative;
      /*padding-top: toRem(14);*/
      line-height: toRem(58);
      font-family: PingFangSC-Light;
      font-size: toRem(22);
      color: #1c1717;
      .urgent {
        color: #f8a120;
      }
    }
    .instructions {
      position: absolute;
      right: 0;
      top: 0;
      display: flex;
      align-items: center;
      float: right;
    }
  }
  /*.direction-of-use {*/
  /*height: 0;*/
  /*overflow: hidden;*/
  /*transition: height linear 0.2s;*/
  /*}*/
  .direction-text {
    width: 100%;
    padding: toRem(30);
    font-family: PingFangSC-Light;
    font-size: toRem(24);
    line-height: toRem(38);
    color: #1c1717;
    background-color: #fff;
    box-sizing: border-box;
    @include border-1px(#e1e1e1);
    border-top: none;
  }
}

.used,
.expired {
  .coupon-item {
    .coupon-info {
      background-image: url('../../../public/img/invalid.png');
    }
    .coupon-price,
    .coupon-condition,
    .period,
    .direction-text,
    .coupon-limit {
      color: #999;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/TicketList/components/TicketItem.vue